module.exports = {
  sanity: {
    projectId: process.env.GATSBY_SANITY_PROJECT_ID || '5t8iwfwq',
    dataset: process.env.GATSBY_SANITY_DATASET || 'production'
  }
}
